export default __webpack_public_path__ + "static/media/SAIC.95cf9d5a.png";